import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    alertsRes: null,      // { alerts:[], openCount, acknowledgedCount }
    actionLoading: false, // acknowledge / bump-priority in flight
};

const slice = createSlice({
    name: 'labAlert',
    initialState,
    reducers: {
        // Polled on the dashboard — keeps its own loading flag.
        getAlertsRequest: (state) => { state.loading = true; },
        getAlertsSuccess: (state, action) => { state.loading = false; state.alertsRes = action.payload; },
        getAlertsFailure: (state) => { state.loading = false; },
        resetAlerts: (state) => { state.alertsRes = null; },

        acknowledgeAlertRequest: (state) => { state.actionLoading = true; },
        acknowledgeAlertSuccess: (state) => { state.actionLoading = false; },
        acknowledgeAlertFailure: (state) => { state.actionLoading = false; },

        bumpOrderPriorityRequest: (state) => { state.actionLoading = true; },
        bumpOrderPrioritySuccess: (state) => { state.actionLoading = false; },
        bumpOrderPriorityFailure: (state) => { state.actionLoading = false; },
    }
});

export const {
    getAlertsRequest, getAlertsSuccess, getAlertsFailure, resetAlerts,
    acknowledgeAlertRequest, acknowledgeAlertSuccess, acknowledgeAlertFailure,
    bumpOrderPriorityRequest, bumpOrderPrioritySuccess, bumpOrderPriorityFailure,
} = slice.actions;

export default slice.reducer;
